import useSWR from "swr";
import { getClaimTypes } from "./clients-service";
import { UseClaimTypesModel } from "./types";

const useClaimTypes = (): UseClaimTypesModel => {
  const { data, error, mutate } = useSWR(`/claim/type`, () => getClaimTypes());

  return {
    data: data?.results ?? [],
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useClaimTypes;
